const featureFlags = [
  'reload_page_message',
  'transport_tips',
  'next_day_delivery',
  'shopify_integration',
  'new_delivery_types_in_history',
  'disable_new_users_visiting_inner_pages',
  'enable_coupon_feature',
  'vn_show_update_consent_timestamp_dialog',
  'transport_epod_photo',
  'delivery_tips',
  'enable_smart_tunnel_suggestion',
  'enable_fixed_moving_fee_enhancement',
  'custom_tp_tips',
  'enable_fe_generate_files',
  'require_merchant_order_note',
  'login_ui_v3',
]

export { featureFlags }
